import {ExtraOptions, Routes} from '@angular/router';
import {AuditPivotComponent} from "../reports/audit-pivot/audit-pivot.component";
import {CalculationCheckTableComponent} from "../tables/calculation-check-table/calculation-check-table.component";
import {
    EngineeringUnitViewComponent
} from "../handson-sheets/engineering-unit-sheet-view/engineering-unit-sheet-view.component";
import {RegisterUserView} from "../user_control/register.component";
import {CollectorEventsTableComponent} from "../tables/collector-events-table/collector-events-table.component";
import {QuickChartsComponent} from "../charts/quick-charts.component";
import {
    StreamSheetFocusViewComponent
} from "../handson-sheets/stream-sheet-focus-view/stream-sheet-focus-view.component";
import {
    CollectorMapperSheetViewComponent
} from "../handson-sheets/collector-mapper-sheet-view/collector-mapper-sheet-view.component";
import {
    EquipmentSheetFocusViewComponent
} from "../handson-sheets/equipment-sheet-focus-view/equipment-sheet-focus-view.component";
import {PageViewComponent} from "../page-view/page-view/page-view.component";
import {ShiftSheetViewComponent} from "../handson-sheets/shift-sheet-view/shift-sheet-view.component";
import {
    SeriesComponentSheetFocusViewComponent
} from "../handson-sheets/series-component-sheet-focus-view/series-component-sheet-focus-view.component";
import {SeriesTableFocusViewComponent} from "../tables/series-table-focus-view/series-table-focus-view.component";
import {
    CustomProcessViewComponent
} from "../handson-sheets/custom-process-sheet-view/custom-process-sheet-view.component";
import {
    ProcessSheetFocusViewComponent
} from "../handson-sheets/process-sheet-focus-view/process-sheet-focus-view.component";
import {EstimateSheetViewComponent} from "../handson-sheets/estimate-sheet-view/estimate-sheet-view.component";
import {LogSheetFocusViewComponent} from "../data-sheets/log-sheet/log-sheet-focus-view.component";
import {ResourceSheetViewComponent} from "../handson-sheets/resource-sheet-view/resource-sheet-view.component";
import {
    ProcessAccessSheetViewComponent
} from "../handson-sheets/process-access-sheet-view/process-access-sheet-view.component";
import {
    SeriesSheetFocusViewComponent
} from "../handson-sheets/series-sheet-focus-view/series-sheet-focus-view.component";
import {SeriesSheetViewComponent} from "../handson-sheets/series-sheet-view/series-sheet-view.component";
import {FlowchartFocusViewComponent} from "../flowchart/flowchart-focus-view/flowchart-focus-view.component";
import {EstimateDataSheetViewComponent} from "../data-sheets/estimate-data-sheet-view.component";
import {WelcomeComponent} from "../user_control/welcome.component";
import {InputDataSheetFocusViewComponent} from "../data-sheets/input-data-sheet-focus-view.component";
import {ProcessSheetViewComponent} from "../handson-sheets/process-sheet-view/process-sheet-view.component";
import {
    SeriesComponentSheetViewComponent
} from "../handson-sheets/series-component-sheet-view/series-component-sheet-view.component";
import {EventPivotComponent} from "../events/event-pivot.component";
import {EquipmentSheetViewComponent} from "../handson-sheets/equipment-sheet-view/equipment-sheet-view.component";
import {StreamSheetViewComponent} from "../handson-sheets/stream-sheet-view/stream-sheet-view.component";
import {EstimateDataSheetFocusViewComponent} from "../data-sheets/estimate-data-sheet-focus-view.component";
import {EstimateSheetFocusViewComponent} from "../data-sheets/estimate-sheet-focus-view.component";
import {AuditHistoryComponent} from "../handson-sheets/audit-history/audit-history.component";
import {HelpPageComponent} from "../components/help-page/help-page.component";
import {EventTypesTableComponent} from "../tables/event-types-table/event-types-table.component";
import {pageViewGuard} from "../services/route-guards/page-view-guard.guard";
import {focusViewGuard} from "../services/route-guards/focus-view-guard.guard";
import {urlGuard} from "../services/route-guards/url-guard.guard";
import {ComponentTypesTableComponent} from '../tables/component-types-table/component-types-table.component';
import {ForbiddenViewComponent} from "../user_control/forbidden-view/forbidden-view.component";
import {
    ComponentEventsTableViewComponent
} from '../tables/component-events-table-view/component-events-table-view.component';
import {
    DataExceptionsTableViewComponent
} from "../tables/data-exceptions-table-view/data-exceptions-table-view.component";
import {
    SingleComponentEventsTableViewComponent
} from "../tables/single-component-events-table-view/single-component-events-table-view.component";
import {
    ValidateComponentTemplatesComponent
} from "../tables/validate-component-templates/validate-component-templates.component";
import {NotFoundViewComponent} from "../user_control/not-found-view/not-found-view.component";
import {LockTemplateTableViewComponent} from "../tables/lock-template-table-view/lock-template-table-view.component";
import {ComponentPanelStackComponent} from "../modals/component-panel-stack/component-panel-stack.component";
import {SolverTemplateTableComponent} from "../tables/solver-template-table/solver-template-table.component";
import {MySecurityComponent} from "../user_control/my-security.component";
import {checkLoginGuard} from "../services/route-guards/check-login-guard.guard";
import {GenerateAuthTokenComponent} from "../user_control/generate-auth-token/generate-auth-token.component";
import {ThemeViewComponent} from "../shared/scss/theme-component/theme-view.component";
import {SubroutePageOutletComponent} from "./subroute-page-outlet/subroute-page-outlet.component";
import {ManageUsersComponent} from "../user_control/manage-users/manage-users.component";
import {userContextLoadedGuard} from "../services/route-guards/user-context-loaded.guard";
import {onboardingUserGuard} from "../services/route-guards/onboarding-user.guard";
import { LockPolicyTableViewComponent } from '../tables/lock-policy-table-view/lock-policy-table-view.component';
import {JobListComponent} from "../jobs/job-list/job-list.component";
import {JobDetailComponent} from "../jobs/job-detail/job-detail.component";

export const routes: Routes = [{
    path: 'onboarding',
    canActivate: [checkLoginGuard, onboardingUserGuard],
    component: SubroutePageOutletComponent,
    loadChildren: () => import('./onboarding/onboarding-routing/onboarding-routing.module').then(m => m.OnboardingRoutingModule)
}, {
    path: 'view', canActivate: [checkLoginGuard, userContextLoadedGuard], children: [
        {path: 'welcome', pathMatch: 'full', component: WelcomeComponent},
        {path: 'forbidden', pathMatch: 'full', component: ForbiddenViewComponent},
        {path: 'notfound', pathMatch: 'full', component: NotFoundViewComponent},
        {path: 'audit_pivot', pathMatch: 'full', component: AuditPivotComponent},
        {
            path: 'calculation_check',
            pathMatch: 'full',
            component: CalculationCheckTableComponent,
        },
        {
            path: 'validate_component_templates',
            pathMatch: 'full',
            component: ValidateComponentTemplatesComponent,
        },
        {
            path: 'engineering_unit',
            pathMatch: 'full',
            component: EngineeringUnitViewComponent
        },
        {path: 'user_list', pathMatch: 'full', component: ManageUsersComponent},
        {path: 'access_token', pathMatch: 'full', component: GenerateAuthTokenComponent},
        {path: 'register_user', pathMatch: 'full', component: RegisterUserView},
        {path: 'quick_charts', pathMatch: 'full', component: QuickChartsComponent},
        {
            path: 'collection_events',
            pathMatch: 'full',
            component: CollectorEventsTableComponent
        },
        {
            path: 'collector_mapper_sheet',
            pathMatch: 'full',
            component: CollectorMapperSheetViewComponent
        },
        {
            path: 'shift_sheet',
            pathMatch: 'full',
            component: ShiftSheetViewComponent
        },
        {
            path: 'edit_series_components',
            pathMatch: 'full',
            component: SeriesComponentSheetViewComponent
        },
        {path: 'event_pivot', pathMatch: 'full', component: EventPivotComponent},
        {
            path: 'edit_process',
            pathMatch: 'full',
            component: ProcessSheetViewComponent
        },
        {
            path: 'estimate_sheet',
            pathMatch: 'full',
            component: EstimateSheetViewComponent
        },
        {
            path: 'estimate_sheet/:processID',
            pathMatch: 'full',
            component: EstimateSheetFocusViewComponent
        },
        {
            path: 'resource_sheet',
            pathMatch: 'full',
            component: ResourceSheetViewComponent
        },
        {
            path: 'process_access_sheet',
            pathMatch: 'full',
            component: ProcessAccessSheetViewComponent
        },
        {
            path: 'edit_series',
            pathMatch: 'full',
            component: SeriesSheetViewComponent
        },
        {
            path: 'analysis_tools',
            pathMatch: 'full',
            loadComponent: () => import('../reports/analysis-tools-view/analysis-tools-view.component').then(m => m.AnalysisToolsViewComponent)
        },
        {
            path: 'estimate_data_sheet',
            pathMatch: 'full',
            component: EstimateDataSheetViewComponent
        },
        {
            path: 'equipment_sheet',
            pathMatch: 'full',
            component: EquipmentSheetViewComponent
        },
        {path: 'my_security', pathMatch: 'full', component: MySecurityComponent},
        {
            path: 'edit_streams',
            pathMatch: 'full',
            component: StreamSheetViewComponent
        },
        {
            path: 'value_driver_trees',
            pathMatch: 'full',
            loadComponent: () =>
                import('../reports/value-driver-tree-view/value-driver-tree-view.component').then(m => m.ValueDriverTreeViewComponent)
        },
        {
            path: 'data_exceptions',
            pathMatch: 'full',
            component: DataExceptionsTableViewComponent
        },
        {
            path: 'audit_history',
            pathMatch: 'full',
            component: AuditHistoryComponent
        },
        {path: 'help-page', pathMatch: 'full', component: HelpPageComponent},
        {
            path: 'event_types',
            pathMatch: 'full',
            component: EventTypesTableComponent
        },
        {
            path: 'component_types',
            pathMatch: 'full',
            component: ComponentTypesTableComponent
        },
        {
            path: 'component_events',
            pathMatch: 'full',
            component: ComponentEventsTableViewComponent
        },
        {
            path: 'single_component_events',
            pathMatch: 'full',
            component: SingleComponentEventsTableViewComponent
        },
        {
            path: 'page_list_view',
            pathMatch: 'full',
            loadComponent: () =>
                import('../page-view/page-list-view/page-list-view.component').then(m => m.PageListViewComponent)
        },

        {
            path: 'custom_process_sheet/:category',
            pathMatch: 'full',
            component: CustomProcessViewComponent
        },

        {
            path: 'series_table/:processID',
            pathMatch: 'full',
            component: SeriesTableFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'log_sheet/:processID',
            pathMatch: 'full',
            component: LogSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'flowchart/:processID',
            pathMatch: 'full',
            component: FlowchartFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'input_data_sheet/:processID',
            pathMatch: 'full',
            component: InputDataSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'edit_series_components/:processID',
            pathMatch: 'full',
            component: SeriesComponentSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'edit_series/:processID',
            pathMatch: 'full',
            component: SeriesSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'edit_sub_process/:processID',
            pathMatch: 'full',
            component: ProcessSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'edit_stream/:processID',
            pathMatch: 'full',
            component: StreamSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'estimate_data_sheet/:processID',
            pathMatch: 'full',
            component: EstimateDataSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'equipment_sheet/:processID',
            pathMatch: 'full',
            component: EquipmentSheetFocusViewComponent,
            canActivate: [focusViewGuard]
        },
        {
            path: 'lock_template_table_view',
            pathMatch: 'full',
            component: LockTemplateTableViewComponent
        },
        {
            path: 'lock_policy_table_view',
            pathMatch: 'full',
            component: LockPolicyTableViewComponent,
        },
        {
            path: 'solver_templates',
            pathMatch: 'full',
            component: SolverTemplateTableComponent
        },
        {
            path: 'theme',
            pathMatch: 'full',
            component: ThemeViewComponent
        },
        {
            path: 'page_view/:sessionID',
            component: PageViewComponent,
            canActivate: [pageViewGuard],
            children: [
                {
                    path: 'component/:tileID',
                    pathMatch: 'full',
                    component: ComponentPanelStackComponent,
                    outlet: 'component_panel',
                }, {
                    path: 'component-detail/:componentID/:tileID',
                    pathMatch: 'full',
                    component: ComponentPanelStackComponent,
                    outlet: 'component_panel'
                },
            ]
        },
        {
            path: 'jobs',
            pathMatch: 'full',
            component: JobListComponent
        },
        {
            path: 'jobs/:jobId',
            pathMatch: 'full',
            component: JobDetailComponent
        },
    ],
}, {
    path: '**',
    component: PageViewComponent,
    canActivate: [checkLoginGuard, userContextLoadedGuard, urlGuard]
}];

const routerOptions: ExtraOptions = {
    onSameUrlNavigation: "reload",
}
